import ModalFeedback from './modal-feedback'

export default ModalFeedback;